type MinimalDocument = {
  createElement(tagName: 'a'): {
    href: string;
    rel: string;
    target?: string;
    style: { display: string };
    click(): void;
  };
  body: {
    appendChild(node: unknown): void;
    removeChild(node: unknown): void;
  };
};

export function openUrl(
  doc: MinimalDocument,
  url: string,
  target?: '_blank',
): void {
  const anchor = doc.createElement('a');
  anchor.href = url;
  if (target) {
    anchor.target = target;
  }
  anchor.rel = 'noopener noreferrer';
  anchor.style.display = 'none';
  doc.body.appendChild(anchor);
  anchor.click();
  doc.body.removeChild(anchor);
}
